import { CLINICAL_COLOURS } from 'src/theme/palette';

// Each record type's accent is its colour in the clinical register
// (src/theme/palette.js); the tints and inks around it are this file's own.
export const TILE_COLOURS = {
  disease: {
    background: '#fff5f5',
    border: '#f5c0c0',
    accent: CLINICAL_COLOURS.disease,
    text: '#b83030',
    subtext: '#c06060'
  },
  phenotype: {
    background: '#f0f9fb',
    border: '#9fd6e2',
    accent: CLINICAL_COLOURS.phenotype,
    text: '#1a7a8f',
    subtext: '#3e9aab'
  },
  genotype: {
    background: '#f7f4fd',
    border: '#c9b5ed',
    accent: CLINICAL_COLOURS.genotype,
    text: '#512ea0',
    subtext: '#7555bb'
  }
};
